import { ReviewDistributionValue } from "@omni/types/api/reviews/bff/shared/reviewDistributionValue.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { PopOver } from "@/components/General/PopOver/popOver.component";
import { Rating } from "@/components/Product/Rating/rating.component";
import { StarFilter } from "@/components/Product/Reviews/reviewsSummary/components/starFilter/starFilter.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { formatNumber } from "@/utils/format";

export type DefaultRatingSummaryProps = {
    value: number;
    count: number;
    distributions: Array<ReviewDistributionValue>;
    writeReview: () => void;
    goToReviews: () => void;
};

const DefaultRatingSummaryComponent = ({
    value,
    count,
    distributions = [],
    writeReview,
    goToReviews
}: DefaultRatingSummaryProps) => {
    const { t } = useGranite();

    return (
        <div
            className={cn(
                "tw:inline-flex tw:flex-row tw:gap-2 tw:items-center"
            )}
        >
            <PopOver
                onHover={true}
                onClick={false}
                placement={"bottom"}
                anchorComponent={(
                    setReference,
                    getReferenceProps,
                    popOverComponent
                ) => (
                    <>
                        <Button
                            size={"sm"}
                            color={"link"}
                            className={cn("tw:inline-flex tw:gap-4 tw:p-0")}
                            ref={setReference}
                            {...getReferenceProps()}
                            onClick={goToReviews}
                        >
                            <Rating
                                value={value}
                                size={16}
                            />
                            <span>
                                {formatNumber(value, Config.getLocale(), {
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1
                                })}
                            </span>
                            <div>{`(${formatNumber(count, Config.getLocale())})`}</div>
                        </Button>
                        {popOverComponent()}
                    </>
                )}
            >
                <div className={cn("tw:p-4 tw:flex tw:flex-col")}>
                    <StarFilter
                        totalReviews={count}
                        distribution={distributions}
                        readonly={true}
                    />
                    <Button
                        size={"sm"}
                        className={cn("tw:block tw:mt-4")}
                        onClick={goToReviews}
                    >
                        {t("general.reviews.summary.popover.goto", count)}
                    </Button>
                </div>
            </PopOver>
            <div>
                <Button
                    size="sm"
                    color="link"
                    aria-label={t("general.reviews.write.aria")}
                    onClick={writeReview}
                    className={cn("tw:p-0")}
                >
                    {t("general.reviews.write")}
                </Button>
            </div>
        </div>
    );
};

export { DefaultRatingSummaryComponent };
